import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MenuItem } from '../../interfaces/menu-item.interface';
import { LinkTypeEnum } from '../../../../enums/link-type.enum';

@Component({
  selector: 'app-menu-link',
  templateUrl: './menu-link.component.html',
  styleUrls: ['./menu-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuLinkComponent {
  @Input()
  isActive: boolean = false;
  @Input()
  styleClass: string = '';
  @Input('item')
  set menuItem(item: MenuItem) {
    this.item = item;
    this.linkStyle = this.item && this.item.iconUrl ? { 'background-image': `url(${this.item.iconUrl})` } : null;
  }

  public item: MenuItem;
  public linkStyle: { [key: string]: string } | null = null;

  public linkTypeEnum = LinkTypeEnum;

  public handleMouseDown(event: MouseEvent, item: MenuItem): void {
    if (item.onClick) {
      item.onClick(event);
    }
  }
}
